export default "__VITE_ASSET__DMQogR6E__"